<script>
import { reactive } from "vue";
import { Head, Link, router } from '@inertiajs/vue3';
import BreezeLayout from '@/Layouts/Authenticated.vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeTextarea from '@/Components/Textarea.vue';
import BreezeLabel from '@/Components/Label.vue';

export default {
    components: {
        BreezeLayout,
        BreezeButton,
        BreezeInput,
        BreezeTextarea,
        BreezeLabel,
        Head,
        Link,
        reactive,
    },

    props: {
        client: Object,
        brand_slugs: Object,
    },

    setup(props) {
        const form = reactive({
            name: props.client.name,
            secret: null,
            redirect: props.client.redirect,
            password_client: props.client.password_client,
            personal_access_client: props.client.personal_access_client,
            revoked: props.client.revoked,
            brand_slug: props.client.brand_slug,
            styles: props.client.styles,
            password_client: props.client.password_client,
        });

        const update = () => {
            router.put(route('clients.update', { client: props.client.id }), form);
        };

        const destroy = () => {
            if (confirm("You are about to delete client: "+ props.client.name + ", are you sure? This cannot be undone.")) {
                router.delete(route("clients.destroy", props.client.id));
            }
        };

        const generate = () => {
            if (confirm("You are about to regenerate the client secret, are you sure? This cannot be undone and the previous secret WILL BE LOST.")) {
                router.post(route("clients.generate", { client: props.client.id }));
            }
        };

        return {
            form,
            update,
            destroy,
            generate
        };
    },
}
</script>
<template>
    <Head title="Add App"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('clients.index')">Clients</Link>&nbsp;/ {{ client.name }}
            </h2>

        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

                <div class="bg-gray-100">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div class="mt-10 sm:mt-0">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1 flex justify-between flex-col">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Editing Client</h3>
                                        <p class="mt-5 text-sm text-gray-600">
                                            <strong>Few important details:</strong>
                                        </p>
                                        <ul class="mt-1 text-sm text-gray-600 list-disc">
                                            <li class="ml-5 mb-4">The client secret cannot be retrieved, this was shared when it was created.</li>
                                            <li class="ml-5 mb-4">Make sure the redirect URL is correct, otherwise you will get 401 or 403 errors. Also check if communication between systems on this URL is working properly, DNS resolving, hostfiles & firewalls.</li>
                                            <li class="ml-5 mb-4">Client Id is what is stored in BGS as ApiName</li>
                                            <li class="ml-5 mb-4">If you want to use multiple API's with the same brand of logins, enter the additional redirect urls as comma separated: redirect1.url,redirect2.url,etc..</li>
                                        </ul>
                                    </div>
                                    <div class="pb-2">
                                        <Link :href="route('clients.index')" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-slate-400 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-600">← BACK</Link>
                                    </div>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">

                                    <form @submit.prevent="update">

                                        <div class="shadow overflow-hidden sm:rounded-md">
                                            <div class="px-4 py-5 bg-white sm:p-6 relative">

                                                <breeze-button
                                                    class="text-red-600 absolute end-5 top-3 p-1 text-xl"
                                                    type="button"
                                                    @click="destroy"
                                                >
                                                    Remove
                                                </breeze-button>

                                                <breeze-button
                                                    class="text-green-600 absolute end-5 top-12 p-1 text-xl"
                                                    type="button"
                                                    @click="generate"
                                                >
                                                    Regenerate Secret
                                                </breeze-button>

                                                <div class="grid grid-cols-6 gap-6">

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="redirect"
                                                            value="Client Id"
                                                            extra="Used as client identifier"/>
                                                        <BreezeInput
                                                            id="client-id"
                                                            type="text"
                                                            v-model="client.id"
                                                            disabled />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="name"
                                                            value="Name"
                                                            extra="Just a label" />
                                                        <BreezeInput
                                                            id="name"
                                                            type="text"
                                                            v-model="form.name"
                                                            required
                                                            autofocus
                                                            autocomplete="name" />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="redirect"
                                                            value="Redirect URL"
                                                            extra="Comma separated if more than 1 url is required." />
                                                        <BreezeInput
                                                            id="redirect"
                                                            type="text"
                                                            v-model="form.redirect"
                                                            required
                                                            autocomplete="redirect" />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="secret"
                                                            value="Client secret"
                                                            extra="You can update the secret, or leave it blank to not changing it." />
                                                        <BreezeInput
                                                            id="redirect"
                                                            type="text"
                                                            v-model="form.secret"
                                                            autocomplete="secret" />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                        for="password_client"
                                                        value="Password client" />
                                                        <select v-model="form.password_client" id="password_client" name="password_client"
                                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                            <option value="1">true</option>
                                                            <option value="0">false</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                        for="personal_access_client"
                                                        value="Password Access Client" />
                                                        <select v-model="form.personal_access_client" id="personal_access_client" name="personal_access_client"
                                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                            <option value="1">true</option>
                                                            <option value="0">false</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                                for="brand_slug"
                                                                value="Brand slug"
                                                                extra="" />
                                                        <BreezeInput
                                                                id="brand_slug"
                                                                type="text"
                                                                v-model="form.brand_slug"
                                                                required
                                                                autofocus
                                                                autocomplete="brand_slug" />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                                for="styles"
                                                                value="Brand Styles"
                                                                extra="flat CSS" />
                                                        <BreezeTextarea
                                                                id="styles"
                                                                type="text"
                                                                v-model="form.styles"
                                                                required
                                                                autofocus
                                                                autocomplete="styles" />
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="password_client"
                                                            value="Is password grant client" />
                                                        <select v-model="form.password_client" id="password_client" name="password_client"
                                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                            <option value="1">Yes, password grant</option>
                                                            <option value="0">No, authorization grant</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="revoked"
                                                            value="Is revoked" />
                                                        <select v-model="form.revoked" id="revoked" name="revoked"
                                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                            <option value="1">Yes</option>
                                                            <option value="0">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="flex justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                <BreezeButton
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    :class="{ 'opacity-25': form.processing }"
                                                    :disabled="form.processing">
                                                    Update
                                                </BreezeButton>

                                            </div>

                                        </div>


                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </BreezeLayout>

</template>
